import React from 'react';
import { HTMLTable } from './html_table';
import { Buttons } from './example_items/buttons';
import Checkboxes from './example_items/checkboxes';
import { Inputs } from './example_items/inputs';
import RadioButtons from './example_items/radio_buttons';
import { Labels } from './example_items/labels';
import { Typography } from './example_items/typography';
import { Colors } from './example_items/colors';
import { Icons } from './example_items/icons';
import { Dropdown } from './example_items/dropdown';

export const Item = ({ itemType }) => {
  const itemDesc = {
    Buttons:
      "For cross browser reasons, wrap the button text in a container when including an icon or image in the button.",
    Checkboxes:
      "Create checkboxes either with React or straight html. A react example can be found in the user permissions management bulk invite. Checkbox size defaults to small.",
    RadioButtons:
      "Create radio buttons either with React or straight html.",
    Inputs:
      "Inputs! Always use in conjunction with labels. Where do we use them? How should the widths change for differnt applications? What are input pitfalls?",
    Labels:
      "Labels! Woot! Labels should always be used in conjunction with the inputs element",
    Typography:
      "Important info about the typography, where should each be used and when",
    Colors:
      "Colors are sweet, check em out!",
    Icons:
      "You can find the icon font in the app/assets/stylesheets/library_master/styles/icons.scss file. If the icon is purely decorative add aria-hidden=\"true\" to the attribute. If it needs accessibility then you can add an aria-label=\"label name\" to the attribute",
    Dropdown:
      "This component provides the functionality needed for a dropdown menu with limited styling. Create the html structure with the required classes. Add javascript where needed to toggle the expanded and collapsed classes on the dropdown parent- this will differ for jquery and react. The dropdown is HTML element agnostic, though it's best practice to use the elements shown in the following example. For accessibility reasons, the dropdown container should be the first child of the dropdown parent. Make sure to add the mixin for the desktop hover functionality using the 'desktop-view' class attached to the 'body' element."
  };

  const itemComponents = {
    Buttons: <Buttons />,
    Checkboxes: <Checkboxes />,
    RadioButtons: <RadioButtons />,
    Inputs: <Inputs />,
    Labels: <Labels />,
    Typography: <Typography />,
    Colors: <Colors />,
    Icons: <Icons />,
    Dropdown: <Dropdown />
  };

  if (itemType) {
    return (
      <section
        id={`${itemType.toLowerCase()}-container`}
        className="item-container"
      >
        <div className="item-hero">
          <h3 className="item-title">{itemType}</h3>
          <p className="item-desc">{itemDesc[itemType]}</p>
        </div>
        {itemComponents[itemType]}
        <HTMLTable itemType={itemType} />
      </section>
    );
  }

  return undefined;
};
